import React, { useContext, useEffect, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { refreshPage, removeUserSession } from "../../Helpers/Utils/Common"
import { getName, getType } from "../../Helpers/Utils/Common"
import MenuItem from "./MenuItem"
import { toastStyle } from "../../Helpers/Utils/Common"
import toast from "react-hot-toast"
import "../Navbar/Navbar.css"
import logout from "../../Assets/Images/Navbar/logout.png"
import ElmhurstLogo2 from "../../Assets/Images/elmhurst-initial-logo-2.png"
import DashboardCustomizeOutlinedIcon from "@mui/icons-material/DashboardCustomizeOutlined"
import WarehouseOutlinedIcon from "@mui/icons-material/WarehouseOutlined"
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined"
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined"
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined"
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined"
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined"
import KitchenOutlinedIcon from "@mui/icons-material/KitchenOutlined"
import AddShoppingCartOutlinedIcon from "@mui/icons-material/AddShoppingCartOutlined"
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined"
import SellOutlinedIcon from "@mui/icons-material/SellOutlined"
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined"
import SellIcon from "@mui/icons-material/Sell"
import DescriptionIcon from "@mui/icons-material/Description"
import PaidIcon from "@mui/icons-material/Paid"
import AttachMoneyIcon from "@mui/icons-material/AttachMoney"
import SourceIcon from "@mui/icons-material/Source"
import FactCheckIcon from "@mui/icons-material/FactCheck"
import { MenuOutlined } from "@ant-design/icons"

const Navbar = (props) => {
  //ADMIN
  const adminMenu = [
    {
      name: "DASHBOARD",
      exact: true,
      to: "/dashboard",
      // iconClassName: cp,
      iconClassName: <DashboardCustomizeOutlinedIcon />,
      expand: true,
    },
    {
      name: "SALES",
      exact: true,
      to: "/",
      iconClassName: <SellOutlinedIcon />,
      subMenus: [
        { name: "Customers", to: "/customers" },
        { name: "Quotations", to: "/salesquotation" },
        { name: "Orders", to: "/salesorder" },
        { name: "Invoices", to: "/wholesaleinvoice" },
        { name: "Payments", to: "/salespayment" },
      ],
      expand: true,
    },
    {
      name: "SALES REPORTS",
      exact: true,
      to: "/",
      iconClassName: <SummarizeOutlinedIcon />,
      subMenus: [
        { name: "Receivable Aging", to: "/receivablesagingreport" },
        { name: "Top Selling Items", to: "/wholesale-top-selling-item" },
      ],
      expand: true,
    },
    {
      name: "PURCHASES",
      exact: true,
      to: "/",
      iconClassName: <AddShoppingCartOutlinedIcon />,
      subMenus: [
        // { name: "New Purchase Request", to: "/purchaserequest/add" },
        // { name: "New Purchase Order", to: "/purchaseorders/add" },
        // { name: "Requests", to: "/purchaserequest" },
        { name: "Orders", to: "/purchaseorders" },
        { name: "Invoices", to: "/purchaseinvoices" },
        { name: "Payments", to: "/paysuppliers" },
        { name: "Returns", to: "/purchasereturn" },
        { name: "Replacements", to: "/purchasereplacement" },
      ],
      expand: true,
    },

    // {
    //   name: "PURCHASE PAYMENTS",
    //   exact: true,
    //   to: "/",
    //   iconClassName: <PaidIcon />,
    //   subMenus: [
    //     { name: "Purchase Payments", to: "/paysuppliers" },
    //     { name: "New Cash Payment", to: "/paysuppliers/add/cash" },
    //     { name: "New Check Payment", to: "/paysuppliers/add/check" },
    //     { name: "New Bank Payment", to: "/paysuppliers/add/bank" },
    //     { name: "New Others Payment", to: "/paysuppliers/add/other" },
    //   ],
    //   expand: true,
    // },
    {
      name: "INVENTORY",
      exact: true,
      to: "/",
      iconClassName: <WarehouseOutlinedIcon />,
      subMenus: [
        // { name: "Build Item", to: "/builditem" },
        { name: "Items List", to: "/itemlists" },
        { name: "Low on Stock", to: "/lowonstock" },
        { name: "Items History", to: "/itemhistorysearch" },
        { name: "Adjustments", to: "/adjustments" },
      ],
      expand: true,
    },
    {
      name: "OTHER EXPENSES",
      exact: true,
      to: "/",
      iconClassName: <KitchenOutlinedIcon />,
      subMenus: [
        // { name: "New Supplies PO", to: "/suppliesexpenses/add" },
        { name: "Expense PO", to: "/suppliesexpenses" },
        {
          name: "Expense Invoice",
          to: "/se/purchaseinvoices",
        },
        { name: "Expense Payments", to: "/se/paysuppliers" },
      ],
      expand: true,
    },
    // {
    //   name: "SUPPLIES PAYMENTS",
    //   exact: true,
    //   to: "/",
    //   iconClassName: <AttachMoneyIcon />,
    //   subMenus: [
    //     { name: "Supplies Payments", to: "/se/paysuppliers" },
    //     { name: "New SE Cash Payment", to: "/se/paysuppliers/add/cash" },
    //     { name: "New SE Check Payment", to: "/se/paysuppliers/add/check" },
    //     { name: "New SE Bank Payment", to: "/se/paysuppliers/add/bank" },
    //     { name: "New SE Others Payment", to: "/se/paysuppliers/add/other" },
    //   ],
    //   expand: true,
    // },
    {
      name: "EXPENSE REPORTS",
      exact: true,
      to: "/",
      iconClassName: <MonetizationOnOutlinedIcon />,
      subMenus: [
        { name: "Expense By Type", to: "/expensebytype" },
        // { name: "Expense By Date", to: "/expensebydate" },
        { name: "Payables Aging", to: "/payablesagingreport" },
        { name: "Purchased Items", to: "/purchaseditems" },
        { name: "Supplier Prices", to: "/supplier-price-report" },
      ],
      expand: true,
    },
    {
      name: "FINANCIAL REPORT",
      exact: true,
      to: "/",
      iconClassName: <AccountBalanceWalletOutlinedIcon />,
      subMenus: [
        { name: "Issued Payments", to: "/purchaseissuedpayment" },
        { name: "General Journal", to: "/generaljournal" },
        { name: "Journal Entry Listing", to: "/journalentrylisting" },
        { name: "Cash Flow Statement", to: "/cashflowstatement" },
        {
          name: "P/L Statement or Balance Sheet",
          to: "/plstatement-balancesheet",
        },
        { name: "Trial Balance", to: "/trialbalance" },
      ],
      expand: true,
    },
    // {
    //   name: "TRANSFERS",
    //   exact: true,
    //   to: "/",
    //   iconClassName: <LocalShippingOutlinedIcon/>,
    //   subMenus: [
    //     { name: "Gate Pass", to: "/gatepass" },
    //     { name: "Requests", to: "/requests" },
    //     { name: "Transfer Register", to: "/transfers" },
    //     { name: "Transfer Receives", to: "/transfer-receive" },
    //     { name: "Transfer History", to: "/transferhistory" },
    //   ],
    //   expand: true,
    // },
    // {
    //   name: "STORE INVENTORY",
    //   exact: true,
    //   to: "/",
    //   iconClassName: <StorefrontOutlinedIcon/>,
    //   subMenus: [
    //     { name: "Branch Inventory", to: "/branchinventory" },
    //     { name: "Store Adjustments", to: "/storeadjustments" },
    //     { name: "Daily Usage", to: "/dailyusage" },
    //   ],
    //   expand: true,
    // },
    // {
    //   name: "STORE REPORTS",
    //   exact: true,
    //   to: "/",
    //   iconClassName: <SourceIcon/>,
    //   subMenus: [
    //     { name: "List of Stores", to: "/listofstores" },
    //     { name: "Peak Hours", to: "/peakhours" },
    //     { name: "Daily Attendance List", to: "/dailyattendancelist" },
    //     // { name: "Grabfood Report", to: "/grabfoodreport" },
    //     // { name: "Foodpanda Report", to: "/foodpandareport" },
    //     { name: "Sales Per Product Report", to: "/salesperproduct" },
    //     // { name: "Sales Summary", to: "/salessummarygraph" },
    //     { name: "Store Discount Report", to: "/storediscountreport" },
    //     { name: "Retail Top Selling Items", to: "/retail-top-selling-item" }
    //   ],
    //   expand: true,
    // },
    // {
    //   name: "DS REPORTS",
    //   exact: true,
    //   to: "/",
    //   iconClassName: <DescriptionIcon/>,
    //   subMenus: [
    //     { name: "Daily Sales", to: "/dailysales" },
    //     { name: "Daily Orders", to: "/dailyorders" },
    //     { name: "Store Deposit", to: "/storedeposit" },
    //     { name: "Daily Cash Count", to: "/dailycashcount" },
    //     { name: "Daily Expenses", to: "/dailyexpenses" },
    //     { name: "Daily Wastage", to: "/dailywastage" },
    //     { name: "Wastage Reports", to: "/wastagereports" },
    //     { name: "Supplier Price Reports", to: "/supplier-price-report" },
    //   ],
    //   expand: true,
    // },
    {
      name: "PETTY CASH",
      exact: true,
      to: "/pettycash",
      iconClassName: <PaymentsOutlinedIcon />,
      // subMenus: [{ name: "Petty Cash Register", to: "/pettycash" }],
      expand: true,
    },
    {
      name: "MANAGE ITEM",
      exact: true,
      to: "/",
      iconClassName: <FactCheckIcon />,
      subMenus: [
        { name: "Items", to: "/items" },
        { name: "Item Prices", to: "/itemprices" },
        // { name: "Discounts", to: "/discounts" },
        // { name: "Categories", to: "/category" },
        // { name: "Price Levels", to: "/pricelevels" },
        // { name: "Inventory Levels", to: "/inventorylevel" },
      ],
      expand: true,
    },
    {
      name: "MANAGE",
      exact: true,
      to: "/",
      iconClassName: <SettingsOutlinedIcon />,
      subMenus: [
        { name: "Banks", to: "/banks" },
        // { name: "Branch", to: "/branches" },
        { name: "Forwarders", to: "/forwarders" },
        { name: "Suppliers", to: "/suppliers" },
        // { name: "Terminals", to: "/terminals" },
        { name: "Users", to: "/users" },
        // { name: "Warehouses", to: "/warehouses" },
      ],
      expand: true,
    },
    // {
    //   name: "PAYROLL",
    //   exact: true,
    //   to: "/",
    //   iconClassName: <AccountBalanceWalletOutlinedIcon/>,
    //   subMenus: [

    //     { name: "Attendance", to: "/employeehours" },
    //     { name: "Ca and Loans", to: "/cashadvance" },
    //     { name: "Employees", to: "/employees" },
    //     { name: "Employee Deductions", to: "/deductions/0/all/all" },
    //     { name: "Departments", to: "/departments" },
    //     { name: "Holiday", to: "/holiday" },
    //     { name: "Payroll", to: "/payrollmultiple" },
    //     { name: "Scheduler", to: "/scheduler" },

    //   ],
    //   expand: true,
    // },
    // {
    //   name: "REPORTS",
    //   exact: true,
    //   to: "/",
    //   iconClassName: <AssessmentOutlinedIcon />,
    //   subMenus: [
    //     { name: "Audit Trails", to: "/audittrailsreport" },
    //     { name: "Ejournal", to: "/ejournalreport" },
    //     { name: "XReading", to: "/xreadingreport" },
    //     { name: "ZReading", to: "/zreadingreport" },
    //   ],
    //   expand: true,
    // },
  ]

  // -----------------------------------------------------------------
  // ACCOUNT/ACCOUNTING OFFICER
  const accountOfficerMenu = [
    {
      name: "PURCHASES",
      exact: true,
      to: "/",
      iconClassName: <AddShoppingCartOutlinedIcon />,
      subMenus: [
        { name: "Purchase Invoice Register", to: "/purchaseinvoices" },
      ],
      expand: true,
    },
    {
      name: "PURCHASE PAYMENTS",
      exact: true,
      to: "/",
      iconClassName: <PaidIcon />,
      subMenus: [
        { name: "Purchase Payments", to: "/paysuppliers" },
        { name: "New Cash Payment", to: "/paysuppliers/add/cash" },
        { name: "New Check Payment", to: "/paysuppliers/add/check" },
        { name: "New Bank Payment", to: "/paysuppliers/add/bank" },
        { name: "New Others Payment", to: "/paysuppliers/add/other" },
      ],
      expand: true,
    },
    {
      name: "SUPPLIES",
      exact: true,
      to: "/",
      iconClassName: <KitchenOutlinedIcon />,
      subMenus: [
        {
          name: "Supplies Invoice Register",
          to: "/se/purchaseinvoices",
        },
      ],
      expand: true,
    },
    {
      name: "SUPPLIES PAYMENTS",
      exact: true,
      to: "/",
      iconClassName: <AttachMoneyIcon />,
      subMenus: [
        { name: "Supplies Payments", to: "/se/paysuppliers" },
        { name: "New SE Cash Payment", to: "/se/paysuppliers/add/cash" },
        { name: "New SE Check Payment", to: "/se/paysuppliers/add/check" },
        { name: "New SE Bank Payment", to: "/se/paysuppliers/add/bank" },
        { name: "New SE Others Payment", to: "/se/paysuppliers/add/other" },
      ],
      expand: true,
    },
    {
      name: "EXPENSES REPORT",
      exact: true,
      to: "/",
      iconClassName: <MonetizationOnOutlinedIcon />,
      subMenus: [
        { name: "Expense By Type Report", to: "/expensebytype" },
        { name: "Expense By Date Report", to: "/expensebydate" },
        { name: "Payables Aging Report", to: "/payablesagingreport" },
        { name: "Purchased Items", to: "/purchaseditems" },
      ],
      expand: true,
    },
    {
      name: "SALES",
      exact: true,
      to: "/",
      iconClassName: <SellIcon />,
      subMenus: [
        { name: "Sales Invoice", to: "/wholesaleinvoice" },
        { name: "Sales Payment", to: "/salespayment" },
      ],
      expand: true,
    },
    {
      name: "DS REPORTS",
      exact: true,
      to: "/",
      iconClassName: <DescriptionIcon />,
      subMenus: [
        { name: "Daily Sales", to: "/dailysales" },
        { name: "Daily Orders", to: "/dailyorders" },
        { name: "Store Deposit", to: "/storedeposit" },
        { name: "Daily Cash Count", to: "/dailycashcount" },
        { name: "Daily Expenses", to: "/dailyexpenses" },
        { name: "Daily Wastage", to: "/dailywastage" },
        { name: "Wastage Reports", to: "/wastagereports" },
        { name: "Supplier Price Reports", to: "/supplier-price-report" },
      ],
      expand: true,
    },
  ]

  // -----------------------------------------------------------------
  // BIDDING OFFICER
  const biddingOfficerMenu = [
    {
      name: "DASHBOARD",
      exact: true,
      to: "/dashboard",
      // iconClassName: cp,
      iconClassName: <DashboardCustomizeOutlinedIcon />,
      expand: true,
    },
    {
      name: "PURCHASES",
      exact: true,
      to: "/",
      iconClassName: <AddShoppingCartOutlinedIcon />,
      subMenus: [
        { name: "New Purchase Request", to: "/purchaserequest/add" },
        { name: "New Purchase Order", to: "/purchaseorders/add" },
        { name: "Purchase Request Register", to: "/purchaserequest" },
        { name: "Purchase Order Register", to: "/purchaseorders" },
      ],
      expand: true,
    },
    {
      name: "SUPPLIES",
      exact: true,
      to: "/",
      iconClassName: <KitchenOutlinedIcon />,
      subMenus: [
        { name: "New Supplies PO", to: "/suppliesexpenses/add" },
        { name: "Supplies PO Register", to: "/suppliesexpenses" },
      ],
      expand: true,
    },
    {
      name: "SALE",
      exact: true,
      to: "/",
      iconClassName: <SellIcon />,
      subMenus: [
        { name: "Customers", to: "/customers" },
        { name: "Sales Quotation", to: "/salesquotation" },
        { name: "Sales Order", to: "/salesorder" },
      ],
      expand: true,
    },
    {
      name: "MANAGE ITEMS",
      exact: true,
      to: "/",
      iconClassName: <SettingsOutlinedIcon />,
      subMenus: [
        { name: "Items", to: "/items" },
        { name: "Item Prices", to: "/itemprices" },
      ],
    },
  ]

  // -----------------------------------------------------------------
  // PURCHASING OFFICER
  const purchasingOfficerMenu = [
    {
      name: "PURCHASES",
      exact: true,
      to: "/",
      iconClassName: <AddShoppingCartOutlinedIcon />,
      subMenus: [
        { name: "New Purchase Request", to: "/purchaserequest/add" },
        { name: "New Purchase Order", to: "/purchaseorders/add" },
        { name: "Purchase Request Register", to: "/purchaserequest" },
        { name: "Purchase Order Register", to: "/purchaseorders" },
        { name: "Purchase Invoice Register", to: "/purchaseinvoices" },
        { name: "Purchase Return", to: "/purchasereturn" },
        { name: "Purchase Replacement", to: "/purchasereplacement" },
      ],
      expand: true,
    },
    {
      name: "PURCHASE PAYMENTS",
      exact: true,
      to: "/",
      iconClassName: <PaidIcon />,
      subMenus: [
        { name: "Purchase Payments", to: "/paysuppliers" },
        { name: "New Cash Payment", to: "/paysuppliers/add/cash" },
        { name: "New Check Payment", to: "/paysuppliers/add/check" },
        { name: "New Bank Payment", to: "/paysuppliers/add/bank" },
        { name: "New Others Payment", to: "/paysuppliers/add/other" },
      ],
      expand: true,
    },
    {
      name: "SUPPLIES",
      exact: true,
      to: "/",
      iconClassName: <KitchenOutlinedIcon />,
      subMenus: [
        { name: "New Supplies PO", to: "/suppliesexpenses/add" },
        { name: "Supplies PO Register", to: "/suppliesexpenses" },
        {
          name: "Supplies Invoice Register",
          to: "/se/purchaseinvoices",
        },
      ],
      expand: true,
    },
    {
      name: "SUPPLIES PAYMENTS",
      exact: true,
      to: "/",
      iconClassName: <AttachMoneyIcon />,
      subMenus: [
        { name: "Supplies Payments", to: "/se/paysuppliers" },
        { name: "New SE Cash Payment", to: "/se/paysuppliers/add/cash" },
        { name: "New SE Check Payment", to: "/se/paysuppliers/add/check" },
        { name: "New SE Bank Payment", to: "/se/paysuppliers/add/bank" },
        { name: "New SE Others Payment", to: "/se/paysuppliers/add/other" },
      ],
      expand: true,
    },
    {
      name: "WH INVENTORY",
      exact: true,
      to: "/",
      iconClassName: <WarehouseOutlinedIcon />,
      subMenus: [
        { name: "Build Item", to: "/builditem" },
        { name: "Items List", to: "/itemlists" },
        { name: "Low on Stock", to: "/lowonstock" },
        { name: "Items History", to: "/itemhistorysearch" },
        { name: "Warehouse Adjustments", to: "/adjustments" },
      ],
      expand: true,
    },
    {
      name: "STORE INVENTORY",
      exact: true,
      to: "/",
      iconClassName: <StorefrontOutlinedIcon />,
      subMenus: [
        { name: "Branch Inventory", to: "/branchinventory" },
        { name: "Store Adjustments", to: "/storeadjustments" },
        { name: "Daily Usage", to: "/dailyusage" },
      ],
      expand: true,
    },
    {
      name: "MANAGE",
      exact: true,
      to: "/",
      iconClassName: <SettingsOutlinedIcon />,
      subMenus: [{ name: "Suppliers", to: "/suppliers" }],
    },
    {
      name: "MANAGE ITEM",
      exact: true,
      to: "/",
      iconClassName: <FactCheckIcon />,
      subMenus: [{ name: "Items", to: "/items" }],
      expand: true,
    },
    {
      name: "DS REPORTS",
      exact: true,
      to: "/",
      iconClassName: <DescriptionIcon />,
      subMenus: [
        { name: "Daily Expenses", to: "/dailyexpenses" },
        { name: "Daily Wastage", to: "/dailywastage" },
        { name: "Wastage Reports", to: "/wastagereports" },
      ],
      expand: true,
    },
  ]

  // -----------------------------------------------------------
  // WAREHOUSE MANAGER
  const warehouseManager = [
    {
      name: "WH INVENTORY",
      exact: true,
      to: "/",
      iconClassName: <WarehouseOutlinedIcon />,
      subMenus: [
        { name: "Build Item", to: "/builditem" },
        { name: "Items List", to: "/itemlists" },
        { name: "Low on Stock", to: "/lowonstock" },
        { name: "Items History", to: "/itemhistorysearch" },
        { name: "Warehouse Adjustments", to: "/adjustments" },
      ],
      expand: true,
    },
    {
      name: "STORE INVENTORY",
      exact: true,
      to: "/",
      iconClassName: <StorefrontOutlinedIcon />,
      subMenus: [
        { name: "Branch Inventory", to: "/branchinventory" },
        { name: "Store Adjustments", to: "/storeadjustments" },
        { name: "Daily Usage", to: "/dailyusage" },
      ],
      expand: true,
    },
    {
      name: "PURCHASES",
      exact: true,
      to: "/",
      iconClassName: <AddShoppingCartOutlinedIcon />,
      subMenus: [
        { name: "New Purchase Request", to: "/purchaserequest/add" },
        { name: "New Purchase Order", to: "/purchaseorders/add" },
        { name: "Purchase Request Register", to: "/purchaserequest" },
        { name: "Purchase Order Register", to: "/purchaseorders" },
        { name: "Purchase Invoice Register", to: "/purchaseinvoices" },
      ],
      expand: true,
    },
    {
      name: "TRANSFERS",
      exact: true,
      to: "/",
      iconClassName: <LocalShippingOutlinedIcon />,
      subMenus: [
        { name: "Gate Pass", to: "/gatepass" },
        { name: "Requests", to: "/requests" },
        { name: "Transfer Register", to: "/transfers" },
        { name: "Transfer Receives", to: "/transfer-receive" },
        { name: "Transfer History", to: "/transferhistory" },
      ],
      expand: true,
    },
    {
      name: "MANAGE ITEM",
      exact: true,
      to: "/",
      iconClassName: <SettingsOutlinedIcon />,
      subMenus: [
        { name: "Items", to: "/items" },
        { name: "Item Prices", to: "/itemprices" },
        // { name: "Price Levels", to: "/pricelevels" },
      ],
      expand: true,
    },
  ]

  // -----------------------------------------------------------
  // WAREHOUSE ASSISTANT
  const warehouseAssistant = [
    {
      name: "WH INVENTORY",
      exact: true,
      to: "/",
      iconClassName: <WarehouseOutlinedIcon />,
      subMenus: [
        { name: "Build Item", to: "/builditem" },
        { name: "Items List", to: "/itemlists" },
        { name: "Low on Stock", to: "/lowonstock" },
        { name: "Items History", to: "/itemhistorysearch" },
        { name: "Warehouse Adjustments", to: "/adjustments" },
      ],
      expand: true,
    },
    {
      name: "STORE INVENTORY",
      exact: true,
      to: "/",
      iconClassName: <StorefrontOutlinedIcon />,
      subMenus: [
        { name: "Branch Inventory", to: "/branchinventory" },
        { name: "Store Adjustments", to: "/storeadjustments" },
        { name: "Daily Usage", to: "/dailyusage" },
      ],
      expand: true,
    },
    {
      name: "PURCHASES",
      exact: true,
      to: "/",
      iconClassName: <AddShoppingCartOutlinedIcon />,
      subMenus: [
        { name: "New Purchase Request", to: "/purchaserequest/add" },
        { name: "New Purchase Order", to: "/purchaseorders/add" },
        { name: "Purchase Request Register", to: "/purchaserequest" },
        { name: "Purchase Order Register", to: "/purchaseorders" },
        { name: "Purchase Invoice Register", to: "/purchaseinvoices" },
      ],
      expand: true,
    },
    {
      name: "TRANSFERS",
      exact: true,
      to: "/",
      iconClassName: <LocalShippingOutlinedIcon />,
      subMenus: [
        { name: "Gate Pass", to: "/gatepass" },
        { name: "Requests", to: "/requests" },
        { name: "Transfer Register", to: "/transfers" },
        { name: "Transfer Receives", to: "/transfer-receive" },
        { name: "Transfer History", to: "/transferhistory" },
      ],
      expand: true,
    },
    {
      name: "MANAGE ITEM",
      exact: true,
      to: "/",
      iconClassName: <SettingsOutlinedIcon />,
      subMenus: [{ name: "Items", to: "/items" }],
      expand: true,
    },
  ]

  // -----------------------------------------------------------
  //WHOLESALE HEAD
  const wholesaleHead = [
    {
      name: "PURCHASES",
      exact: true,
      to: "/",
      iconClassName: <AddShoppingCartOutlinedIcon />,
      subMenus: [
        { name: "New Purchase Request", to: "/purchaserequest/add" },
        { name: "Purchase Request Register", to: "/purchaserequest" },
      ],
      expand: true,
    },
    {
      name: "SALE",
      exact: true,
      to: "/",
      iconClassName: <SellIcon />,
      subMenus: [
        { name: "Customers", to: "/customers" },
        { name: "Sales Quotation", to: "/salesquotation" },
        { name: "Sales Order", to: "/salesorder" },
        { name: "Sales Invoice", to: "/wholesaleinvoice" },
        { name: "Sales Payment", to: "/salespayment" },
      ],
      expand: true,
    },
    {
      name: "WH INVENTORY",
      exact: true,
      to: "/",
      iconClassName: <WarehouseOutlinedIcon />,
      subMenus: [
        { name: "Build Item", to: "/builditem" },
        { name: "Items List", to: "/itemlists" },
        { name: "Low on Stock", to: "/lowonstock" },
        { name: "Items History", to: "/itemhistorysearch" },
        { name: "Warehouse Adjustments", to: "/adjustments" },
      ],
      expand: true,
    },
    {
      name: "STORE INVENTORY",
      exact: true,
      to: "/",
      iconClassName: <StorefrontOutlinedIcon />,
      subMenus: [
        { name: "Branch Inventory", to: "/branchinventory" },
        { name: "Store Adjustments", to: "/storeadjustments" },
        { name: "Daily Usage", to: "/dailyusage" },
      ],
      expand: true,
    },
  ]

  // -----------------------------------------------------------
  //WHOLESALE ASSISTANT
  const wholesaleAssistant = [
    {
      name: "PURCHASES",
      exact: true,
      to: "/",
      iconClassName: <AddShoppingCartOutlinedIcon />,
      subMenus: [
        { name: "New Purchase Request", to: "/purchaserequest/add" },
        { name: "Purchase Request Register", to: "/purchaserequest" },
      ],
      expand: true,
    },
    {
      name: "SALE",
      exact: true,
      to: "/",
      iconClassName: <SellIcon />,
      subMenus: [
        { name: "Customers", to: "/customers" },
        { name: "Sales Quotation", to: "/salesquotation" },
        { name: "Sales Order", to: "/salesorder" },
        { name: "Sales Invoice", to: "/wholesaleinvoice" },
        { name: "Sales Payment", to: "/salespayment" },
      ],
      expand: true,
    },
    {
      name: "WH INVENTORY",
      exact: true,
      to: "/",
      iconClassName: <WarehouseOutlinedIcon />,
      subMenus: [
        { name: "Build Item", to: "/builditem" },
        { name: "Items List", to: "/itemlists" },
        { name: "Low on Stock", to: "/lowonstock" },
        { name: "Items History", to: "/itemhistorysearch" },
        { name: "Warehouse Adjustments", to: "/adjustments" },
      ],
      expand: true,
    },
    {
      name: "STORE INVENTORY",
      exact: true,
      to: "/",
      iconClassName: <StorefrontOutlinedIcon />,
      subMenus: [
        { name: "Branch Inventory", to: "/branchinventory" },
        { name: "Store Adjustments", to: "/storeadjustments" },
        { name: "Daily Usage", to: "/dailyusage" },
      ],
      expand: true,
    },
  ]

  // -----------------------------------------------------------
  //BRANCH OIC
  const branchOic = [
    {
      name: "MANAGE",
      exact: true,
      to: "/",
      iconClassName: <SettingsOutlinedIcon />,
      subMenus: [{ name: "BRANCH", to: "/branches" }],
      expand: true,
    },
    {
      name: "STORE REPORTS",
      exact: true,
      to: "/",
      iconClassName: <SourceIcon />,
      subMenus: [
        { name: "List of Stores", to: "/listofstores" },
        { name: "Peak Hours", to: "/peakhours" },
        { name: "Daily Attendance List", to: "/dailyattendancelist" },
        // { name: "Grabfood Report", to: "/grabfoodreport" },
        // { name: "Foodpanda Report", to: "/foodpandareport" },
        { name: "Sales Per Product Report", to: "/salesperproduct" },
        // { name: "Sales Summary", to: "/salessummarygraph" },
        // { name: "Store Discount Report", to: "/storediscountreport" },
        { name: "Retail Top Selling Items", to: "/retail-top-selling-item" },
      ],
      expand: true,
    },
    {
      name: "STORE INVENTORY",
      exact: true,
      to: "/",
      iconClassName: <StorefrontOutlinedIcon />,
      subMenus: [
        { name: "Branch Inventory", to: "/branchinventory" },
        { name: "Store Adjustments", to: "/storeadjustments" },
        { name: "Daily Usage", to: "/dailyusage" },
        { name: "Low on Stock", to: "/lowonstock" },
        { name: "Items History", to: "/itemhistorysearch" },
      ],
      expand: true,
    },
    {
      name: "TRANSFERS",
      exact: true,
      to: "/",
      iconClassName: <LocalShippingOutlinedIcon />,
      subMenus: [
        { name: "Gate Pass", to: "/gatepass" },
        { name: "Requests", to: "/requests" },
        { name: "Transfer Register", to: "/transfers" },
        { name: "Transfer Receives", to: "/transfer-receive" },
        { name: "Transfer History", to: "/transferhistory" },
      ],
      expand: true,
    },
    {
      name: "PURCHASES",
      exact: true,
      to: "/",
      iconClassName: <AddShoppingCartOutlinedIcon />,
      subMenus: [
        { name: "New Purchase Request", to: "/purchaserequest/add" },
        { name: "Purchase Request Register", to: "/purchaserequest" },
      ],
      expand: true,
    },
    {
      name: "DS REPORTS",
      exact: true,
      to: "/",
      iconClassName: <DescriptionIcon />,
      subMenus: [
        { name: "Daily Sales", to: "/dailysales" },
        { name: "Daily Orders", to: "/dailyorders" },
        { name: "Store Deposit", to: "/storedeposit" },
        { name: "Daily Cash Count", to: "/dailycashcount" },
        { name: "Daily Expenses", to: "/dailyexpenses" },
        { name: "Daily Wastage", to: "/dailywastage" },
        { name: "Wastage Reports", to: "/wastagereports" },
        // { name: "Supplier Price Reports", to: "/supplier-price-report" },
      ],
      expand: true,
    },
  ]

  // -----------------------------------------------------------
  //BRANCH INVENTORY OFFICER
  const branchInventoryOfficer = [
    {
      name: "STORE INVENTORY",
      exact: true,
      to: "/",
      iconClassName: <StorefrontOutlinedIcon />,
      subMenus: [
        { name: "Branch Inventory", to: "/branchinventory" },
        { name: "Store Adjustments", to: "/storeadjustments" },
        { name: "Daily Usage", to: "/dailyusage" },
        { name: "Low on Stock", to: "/lowonstock" },
        { name: "Items History", to: "/itemhistorysearch" },
      ],
      expand: true,
    },
    {
      name: "TRANSFERS",
      exact: true,
      to: "/",
      iconClassName: <LocalShippingOutlinedIcon />,
      subMenus: [
        { name: "Gate Pass", to: "/gatepass" },
        { name: "Requests", to: "/requests" },
        { name: "Transfer Register", to: "/transfers" },
        { name: "Transfer Receives", to: "/transfer-receive" },
        { name: "Transfer History", to: "/transferhistory" },
      ],
      expand: true,
    },
    {
      name: "PURCHASES",
      exact: true,
      to: "/",
      iconClassName: <AddShoppingCartOutlinedIcon />,
      subMenus: [
        { name: "New Purchase Request", to: "/purchaserequest/add" },
        { name: "Purchase Request Register", to: "/purchaserequest" },
      ],
      expand: true,
    },
    {
      name: "DS REPORTS",
      exact: true,
      to: "/",
      iconClassName: <DescriptionIcon />,
      subMenus: [
        { name: "Daily Expenses", to: "/dailyexpenses" },
        { name: "Daily Wastage", to: "/dailywastage" },
        { name: "Wastage Reports", to: "/wastagereports" },
        // { name: "Supplier Price Reports", to: "/supplier-price-report" },
      ],
      expand: true,
    },
  ]

  // -----------------------------------------------------------
  //COLLECTION OFFICER
  const collectionOfficer = [
    {
      name: "DS REPORTS",
      exact: true,
      to: "/",
      iconClassName: <DescriptionIcon />,
      subMenus: [
        { name: "Daily Sales", to: "/dailysales" },
        { name: "Daily Orders", to: "/dailyorders" },
        { name: "Store Deposit", to: "/storedeposit" },
        { name: "Daily Cash Count", to: "/dailycashcount" },
        { name: "Daily Expenses", to: "/dailyexpenses" },
        { name: "Daily Wastage", to: "/dailywastage" },
        { name: "Wastage Reports", to: "/wastagereports" },
        { name: "Supplier Price Reports", to: "/supplier-price-report" },
      ],
      expand: true,
    },
  ]

  // logout handler
  async function handleLogout() {
    // const response = await logoutUser();
    removeUserSession()
    window.localStorage.clear()
    toast.success("Logging you out...", {
      style: toastStyle(),
    })
    setTimeout(() => refreshPage(), 1000)
  }

  const [inactive, setInactive] = useState(true)
  const [menuItems, setMenuItems] = useState([])

  const handleExpand = (index) => {
    var list = [...menuItems]

    if (!inactive) {
      for (var i = 0; i < list.length; i++) {
        if (i !== index) {
          list[i]["expand"] = true
        }
      }

      list[index]["expand"] = !list[index]["expand"]

      setMenuItems(list)
    }
  }

  useEffect(() => {
    if (inactive) {
      removeActiveClassFromSubMenu()
    }

    props.onCollapse(inactive)
  }, [inactive])

  const removeActiveClassFromSubMenu = () => {
    document.querySelectorAll(".sub-menu").forEach((el) => {
      el.classList.remove("active")
    })
  }

  useEffect(() => {
    const type = getType()

    switch (type) {
      case "admin":
        setMenuItems(adminMenu)
        break
      case "account_officer":
        setMenuItems(accountOfficerMenu)
        break
      case "bidding_officer":
        setMenuItems(biddingOfficerMenu)
        break
      case "purchasing_officer":
        setMenuItems(purchasingOfficerMenu)
        break
      case "warehouse_manager":
        setMenuItems(warehouseManager)
        break
      case "warehouse_assistant":
        setMenuItems(warehouseAssistant)
        break
      case "wholesale_head":
        setMenuItems(wholesaleHead)
        break
      case "wholesale_assistant":
        setMenuItems(wholesaleAssistant)
        break
      case "branch_oic":
        setMenuItems(branchOic)
        break
      case "branch_inventory_officer":
        setMenuItems(branchInventoryOfficer)
        break
      default:
        break
    }

    let menuItemsList = document.querySelectorAll(".menu-item")
    menuItemsList?.forEach((el, index) => {
      if (menuItems[index]?.name === props?.active) {
        el.classList.add("active")
      }
      el.addEventListener("click", (e) => {
        const next = el.nextElementSibling
        removeActiveClassFromSubMenu()
        menuItemsList.forEach((el) => el.classList.remove("active"))
        el.classList.toggle("active")
        if (next !== null) {
          next.classList.toggle("active")
        }
      })
    })
  }, [])

  return (
    <div
      className="navbar-body"
      onMouseEnter={() => setInactive(!inactive)}
      onMouseLeave={() => setInactive(!inactive)}
    >
      <div
        className="center1 burger-icon"
        onClick={() => setInactive(!inactive)}
      >
        <MenuOutlined className="icon-bars" />
      </div>
      <div
        className={`side-menu ${
          inactive ? "inactive navbar-responsivess" : ""
        }`}
      >
        <div className="top-section">
          <div className="logo d-flex justify-content-center">
            <img
              alt="logo"
              src={ElmhurstLogo2}
              className="navbar-logo"
              onClick={() => setInactive(!inactive)}
            />
          </div>
          <div
            onClick={() => setInactive(!inactive)}
            className="toggle-menu-btn"
          >
            {inactive ? (
              <div className="max-menu-cont">
                <FontAwesomeIcon
                  icon={"angle-double-right"}
                  alt={"open"}
                  className={"max-menu"}
                  aria-hidden="true"
                />
              </div>
            ) : (
              <FontAwesomeIcon
                icon={"angle-double-left"}
                alt={"close"}
                className={"min-menu"}
                aria-hidden="true"
              />
            )}
          </div>
        </div>

        <div className={inactive ? "main-menu" : "main-menu active-menu"}>
          {menuItems.map((menuItem, index) => (
            <MenuItem
              key={index}
              name={menuItem.name}
              exact={menuItem.exact.toString()}
              to={menuItem.to}
              subMenus={menuItem.subMenus || []}
              iconClassName={menuItem.iconClassName}
              expandManage={menuItem.expand}
              setExpandManage={handleExpand}
              index={index}
              activeSub={menuItem.name === props.active}
              onClick={(e) => {
                if (inactive) {
                  setInactive(false)
                }
              }}
            />
          ))}
        </div>
        {!inactive && (
          <>
            <div className="side-menu-footer">
              {!inactive && (
                <div className="user-details-footer">
                  <span className="navbar-user-label">
                    {getName()} |{" "}
                    <span className="user-type-label">{getType()}</span>
                  </span>
                </div>
              )}
              <div className="logout-cont" onClick={() => handleLogout()}>
                <img alt="logo" src={logout} className="logout-btn" />
                <span className="logout-label">LOGOUT</span>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default Navbar
